<template>
  <div class="orderList" ref="orderList" :style="{'padding-top':ulHeight + 'rem'}">
    <div class="headerTitle">
      <choose-btn :icon='iconType'></choose-btn>
      <data-header @select-resturantId ='changeResturantId'></data-header>
    </div>
    <ul v-show="ulIf" class="choose-con" ref="ulHeight">
      <li v-show="payTypeIf" v-for="(itme,index) in payType" :key="index"><span>{{ itme }}</span><img src="../common/image/ch-close.png" @click="delChooseItme('1', itme)"></li>
      <li v-show="paySourceIf" v-for="(itme,index) in paySource" :key="index"><span>{{ itme }}</span><img src="../common/image/ch-close.png" @click="delChooseItme('2', itme)"></li>
      <li v-show="timeIf"><span>{{ startTime }}至{{ endTime }}</span><img src="../common/image/ch-close.png" @click="delChooseItme('3', startTime)"></li>
    </ul>
    <div v-if="dataIf">
      <div id="listCon" class="list_con scrollBody" ref="scrollBody" :style="{'height': scroHeight + 'rem'}">
        <div>
          <div class="floor" v-for="(item, key) in chooseData" v-bind:sort-value="key" :key="key">
            <p class="title"> {{ item.dateIndex }} <span class="moneyTotal">&yen; {{ item.mainMoneyTotal }} </span><span>收款：</span></p>
            <ul>
              <li><span>支付时间</span><span>支付方式</span><span>支付来源</span><span>支付金额</span></li>
              <li v-for="(itemChild,index) in item.dayList" :key="index"><span>{{ itemChild.payTimeStr }}</span><span>{{ itemChild.payType }}</span><span>{{ itemChild.paySourceStr }}</span><span>{{ itemChild.mainMoney }}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>  
    <div v-else class="list_con">
		    <div class="no">暂无数据</div>
    </div>
  </div>
</template> 
<script>
import BScroll from 'better-scroll'
import DataHeader from 'components/dataHeader'
import chooseBtn from 'components/chooseBtn'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      iconType: true,     // 图片
      chooseData: '',
      payType: '',
      paySource: '',
      listTitle: [],
      startTime: '',
      endTime: '',
      ulHeight: 1,
      scroHeight: '',
      divHeight: 0,
      pageIndex: 1,
      pageSize: 500,
      payTypeIf: false,  // 是否显示 筛选项
      paySourceIf: false,  // 是否显示 筛选项
      timeIf: false,  // 是否显示 筛选项
      ulIf: false,  // 是否显示 筛选项
      dataIf: true       // 返回列表数据
    }
  },
  components: {
    DataHeader,
    chooseBtn
  },
  // 加载请求
  mounted() {
    this.getChoosData()
    this.getConfirmFn()
  },
  // 初始化
  creaded() {
  },
  computed: {
    getResturantId: function() {
      return this.$store.state.resturantId
    }
  },
  // 方法
  methods: {
    initScroll() {
      // 上面和下面两个都可以，用下面这个吧，下面这个看着牛逼一点。上面那个就删掉了。initScroll调接口后调用，取得data后调用
      this.$nextTick(() => { // this.$nextTick(() => {})判断dom结构是否完全加载，click: true属性用来设置可以进行点击事件
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.scrollBody, {
            click: true
          })
        } else {
          this.scroll.refresh()
        }
      })
    },
    // 计算高度
    getUlHiegth() {
      this.$nextTick(function() {
        const h = document.body.clientHeight
        this.ulHeight = ((this.$refs.ulHeight.clientHeight) / 100) * 1.82 + 1
        this.scroHeight = (h / 100 * 2) - this.ulHeight - 1.5
      })
    },
    // 获取筛选结果数据
    getChoosData() {
      var data = this.$route.query
      // payType是否有数据
      if (data.payType !== undefined && data.payType !== '') {
        this.payType = data.payType.split(',')
        this.payTypeIf = true
      }
      // paySource是否有数据
      if (data.paySource !== undefined && data.paySource !== '') {
        this.paySource = data.paySource.split(',')
        this.paySourceIf = true
      }
      // time是否有数据
      if (data.startTime !== undefined && data.startTime !== '' && data.endTime !== undefined && data.endTime !== '') {
        this.startTime = data.startTime
        this.endTime = data.endTime
        this.timeIf = true
      }
      // 当筛选项 都为空的时候，父级的UL不显示
      if (this.timeIf === true || this.paySourceIf === true || this.payTypeIf === true) {
        this.ulIf = true
      }
    },
    // 请求列表数据数据
    getConfirmFn() {
      var payTypeStr = ''
      var paySourceArr = []
      var paySourceStr = ''
      const _this = this // vue对象的this 赋给 _this
      if (this.$route.query.payType !== undefined && this.$route.query.payType !== '') {
        payTypeStr = _this.payType.join(',')
      }
      if (this.$route.query.paySource !== undefined && this.$route.query.paySource !== '') {
        for (var i = 0; i < _this.paySource.length; i++) {
          var arr = ''
          if (_this.paySource[i] === 'POS机') {
            arr = '0'
          } else if (_this.paySource[i] === '扫码点餐') {
            arr = '1'
          } else if (_this.paySource[i] === '商家后台') {
            arr = '2'
          }
          paySourceArr.push(arr)
        }
        paySourceStr = paySourceArr.join(',')
      }
      this.$http.get(this.common.url_order + '/searchOrderList', {
        params: {
          payType: payTypeStr,
          paySource: paySourceStr,
          startTime: _this.startTime,
          endTime: _this.endTime,
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize,
          restaurantId: _this.getResturantId,
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          if (response.data.data.length > 0) {
            _this.dataIf = true
            _this.chooseData = response.data.data
            // 处理标题
            // for (let i = 0; i < response.data.data.length; i++) {
            //   const index = response.data.data[i].dateIndex
            //   this.listTitle.push(index)
            // }
            _this.getUlHiegth() // 计算高度
            // 滚动
            _this.initScroll()
          } else {
            _this.dataIf = false
            _this.getUlHiegth() // 计算高度
          }
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    // 删除筛选条件
    delChooseItme(type, name) {
      if (type === '1') {
        this.common.removeByValue(this.payType, name)
      } else if (type === '2') {
        this.common.removeByValue(this.paySource, name)
      } else if (type === '3') {
        this.startTime = []
        this.endTime = []

        // 选择时间的长度为空时
        if (this.startTime.length === 0 || this.endTime.length === 0) {
          this.timeIf = false
        }
      }
      // 当筛选项 都被删除的时候，父级的UL不显示
      if (this.payType.length === 0 && this.paySource.length === 0 && this.startTime.length === 0) {
        this.ulIf = false
      }
      this.getConfirmFn()
    },
    // 门店改变
    changeResturantId() {
      this.getConfirmFn()
    }
  }
}
</script>
<style scoped>
  .orderList{
    width: 100%;
    height: 100%;
    background-color: #f1f2f3;
    overflow: hidden;
  }
  .headerTitle{
    position:fixed;
    top:0;
    left:0;
    z-index: 100;
    width:100%;
    height: 0.9rem;
    line-height: 0.9rem;
    display:flex;
    display: -webkit-flex; 
    justify-content: space-between;
    align-items:center;
    background-color: #ffffff;
    box-shadow: none;
    border-bottom: 1px solid #f1f2f3;
  }
  .headerTitle .storeTitle {
    justify-content: flex-start;
  }
  .titleSpan{
    font-size: 0.28rem;
    font-weight: 600;
    color:#000000;
  }
  .havePayImg{
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.1rem;
  }
  /* 选择条件 */
  .choose-con {
    position: fixed;
    top: 0.9rem;
    left: 0;
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 99;
    font-size: 0;
    padding-left: 0.3rem;
    padding-top: 0.16rem
    /* padding: 0.16rem 0 0 0.3rem */
  }
  .choose-con li {
    width: auto;
    height: .6rem;
    color: #000;
    font-size: .28rem;
    text-align: center;
    line-height: .6rem;
    background: #eee;
    border-radius: .06rem;
    padding: 0 .2rem;
    padding-right: 0;
    margin-right: .2rem;
    margin-bottom: .2rem;
    display: inline-block;
    overflow: hidden;
  }
  .choose-con span {
    float: left;
    width: auto;
    height: 100%;
    display: inline-block;
  }
  .choose-con img {
    width: 0.54rem;
    height: 100%;
    display: inline-block;
  }
  /* .list_con{
  		height: auto;
  } */
  .scrollBody{
    width: 100%;
    height: 10rem;
  }
  .list_con p {
  		width: 100%;
  		height: 0.6rem;
  		line-height: 0.6rem;
  }
  .list_con p.one {
  		background: #fff;
  		padding: 0 0.2rem;
  		margin-bottom: 0.1rem;
  }
  .no {
    width: 100%;
    text-align: center;
  }
  .floor {
  		background: #fff;
  		margin-bottom: 0.1rem;
  }
  .floor li{
  		width: 100%;
  }
  .floor span {
  		width: 25%;
  		height: 100%;
      text-align: center;
  		line-height: inherit;
  		overflow: hidden;
  		display: inline-block;
  }
  .floor p {
    padding: 0 0.2rem;
  }
  .floor p span {
    width: auto;
    max-width: 2.5rem;
    float: right;
  }
  .floor p .moneyTotal {
    width: auto;
    color: #f74d47;
  }
  .floor ul li {
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 0.2rem;
  }
  .floor ul li:first-child {
    color: #555555;
    background: #f7f7f7;
  }
  .list_con .no {
    padding-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderList.vue